export default function Hero() {
  const scrollToForm = () => {
    const formSection = document.getElementById('cta-form');
    if (formSection) {
      formSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden bg-gradient-to-br from-teal-600 via-teal-700 to-cyan-800">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute inset-0" style={{
          backgroundImage: 'radial-gradient(circle at 2px 2px, #fff 1px, transparent 0)',
          backgroundSize: '50px 50px'
        }}></div>
      </div>

      {/* Gradient Overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-transparent to-black/30"></div>

      {/* Content */}
      <div className="relative z-10 max-w-5xl mx-auto px-6 lg:px-12 text-center py-32">
        <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold text-white mb-8 leading-tight">
          Turn Website Inquiries<br />Into Booked Jobs<br />
          Automatically
        </h1>

        <p className="text-xl md:text-2xl text-white/90 mb-6 max-w-3xl mx-auto leading-relaxed">
          Helping Long Island service businesses respond instantly<br />
          to new leads and win more customers — without extra work.
        </p>

        <p className="text-lg text-white/80 mb-12 max-w-2xl mx-auto">
          When customers request a quote, the first business<br />
          to respond usually gets the job.
        </p>

        <button 
          onClick={scrollToForm}
          className="bg-white text-teal-700 px-10 py-5 rounded-full text-lg font-semibold hover:bg-teal-50 transition-all duration-300 shadow-2xl hover:shadow-3xl hover:scale-105 whitespace-nowrap cursor-pointer"
        >
          Get My Free Automation Plan
        </button>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-white text-3xl"></i>
      </div>
    </section>
  );
}
